module.exports = __webpack_public_path__ + "media/images/product/p_i-85291245b5860b3acbfc709faa6eb059.png";